/*
 * @description:
 * @author: Jason Wong
 * @since: 2021-01-11 10:47:09
 */
const SOURCE_TEXT_MAX_LENGTH = 50000;
const DATA_ACTIONS = {
  add: 0,
  edit: 1,
  delete: 2,
};

export { SOURCE_TEXT_MAX_LENGTH, DATA_ACTIONS };

const LANGUAGE_TOOL_SUPPORTED_LANGUAGE_CODES = [
  "中文",
  "英语",
  "法语",
  "德语",
  "日语",
  "俄语",
  "西班牙语",
  "阿拉伯语",
  "菲律宾语",
  "荷兰语",
  "葡萄牙语",
  "瑞典语",
  "意大利语",
  "希腊语",
  "乌克兰语",
  "波兰语",
];
const LANGUAGE_TOOL_SUPPORTED_LANGUAGE_TEXT = LANGUAGE_TOOL_SUPPORTED_LANGUAGE_CODES.join("、");
/**
 *
 * @param {String} lang
 */
function checkLanguageToolSupport(...langs) {
  for (const lang of langs) {
    if (LANGUAGE_TOOL_SUPPORTED_LANGUAGE_CODES.indexOf(lang) < 0) {
      return { success: false, notSupportLangs: lang };
    }
  }
  return { success: true };
}
export { LANGUAGE_TOOL_SUPPORTED_LANGUAGE_CODES, LANGUAGE_TOOL_SUPPORTED_LANGUAGE_TEXT, checkLanguageToolSupport };

const AUTO_CORRECT_SUPPORTED_LANGUAGE_CODES = [
  "中文",
  "英语",
  "法语",
  "德语",
  "日语",
  "俄语",
  "西班牙语",
  "阿拉伯语",
  "韩语",
  "越南语",
  "柬埔寨语",
  "缅甸语",
  "泰语",
  "马来语",
  "菲律宾语",
  "印尼语",
  "印地语",
  "土耳其语",
  "希伯来语",
  "哈萨克语（西里尔文）",
  "乌兹别克语（拉丁文）",
  "荷兰语",
  "葡萄牙语",
  "瑞典语",
  "意大利语",
  "希腊语",
  "乌克兰语",
  "匈牙利语",
  "波兰语",
  "捷克语",
  "塞尔维亚语（西里尔文）",
  "斯瓦希里语",
];
const AUTO_CORRECT_SUPPORTED_LANGUAGE_TEXT = AUTO_CORRECT_SUPPORTED_LANGUAGE_CODES.join("、");
function checkAutoCorrectSupport(...langs) {
  let support = true;
  let notSupportLangs = [];
  for (const lang of langs) {
    if (AUTO_CORRECT_SUPPORTED_LANGUAGE_CODES.indexOf(lang) < 0) {
      support = false;
      notSupportLangs.push(lang);
    }
  }
  if (support) {
    return { success: true };
  } else {
    return { success: false, notSupportLangs: notSupportLangs };
  }
}
export { AUTO_CORRECT_SUPPORTED_LANGUAGE_CODES, AUTO_CORRECT_SUPPORTED_LANGUAGE_TEXT, checkAutoCorrectSupport };

const RTL_LANGUAGES = ["阿拉伯语", "希伯来语"];
function testIsRTL(lang) {
  return RTL_LANGUAGES.indexOf(lang) > -1;
}
export { testIsRTL };

const RESPONSE_WARNING_CODE = 90001;
export { RESPONSE_WARNING_CODE };
